import React from "react";
import "./boxHead.css";
import { bemClassesFromModifiers } from "../../constants/misc";

const BoxHead = (props) => {
  const { title, action, children, style, modifiers } = props;
  const className = props.className ? props.className : "";
  return (
    <div
      style={style}
      className={
        className + " " + bemClassesFromModifiers("box-head", modifiers)
      }
    >
      <div className="box-head__left">
        <h2 className="box-head__title">{title}</h2>
        {children}
      </div>
      <div className="box-head__right">
        <div className="box-head__action">{action}</div>
      </div>
    </div>
  );
};

export default BoxHead;
